module.exports = __webpack_public_path__ + "img/switzerland.1b929a51.svg";